



































































import { Component, Mixins, Ref } from 'vue-property-decorator';
import NavigationCard from '@/NavigationCard';
import RequestButton from '@/RequestButton';
import SelectionBlock from '@/SelectionBlock';
import { LocalKnowItem, KnowItem } from 'src/types/views/know';
import InitData from 'src/mixin/initData';
import { CommonRes } from 'src/types/views/common';
import { SB } from 'src/types/components/selection';

@Component({
  components: { NavigationCard, RequestButton, SelectionBlock },
})
export default class KnowledgeList extends Mixins(InitData) {
  @Ref('s1') readonly s1!: SelectionBlock & SB;

  data: LocalKnowItem[] = [];

  url = 'SearchKnowledge/search';

  queryParam = {
    firstType: '',
    secondType: '',
  };

  beforeInit() {
    this.params = {
      pageNum: this.pageNum,
      pageSize: this.pageSize,
      word: this.keyword,
      wholews: this.wholews,
      knowledgetype: this.queryParam.secondType || this.queryParam.firstType || '',
    };
    return true;
  }

  toDetail(name: string, id: string) {
    this.$router.push({
      name,
      query: { id },
    });
  }

  clear() {
    this.s1.cancelFirstType();
  }

  afterInit(res: CommonRes<KnowItem>) {
    this.data = res.data.rows.map(item => ({
      name: item.title,
      time: item.releaseTime,
      organization: item.releaseOrganization,
      type: item.knowledgetypename,
      id: item.id,
    }));
    this.total = res.data.count || 0;
    return true;
  }

  changeFirstType(id: string) {
    this.queryParam.firstType = id;
    this.queryParam.secondType = '';
    this.toQuery();
  }

  changeSecondType(id: string) {
    this.queryParam.secondType = id;
    this.toQuery();
  }
}
